import Vue from 'vue'
import VueAnalytics from 'vue-analytics'

const gaId = 'UA-127210045-1'
const disableStr = `ga-disable-${gaId}`
const disabled = document.cookie.includes(`${disableStr}=true`)
const host = window.location.hostname
const options = {
  id: gaId,
  disabled,
  checkDuplicatedScript: true,
  set: [
    {
      field: 'anonymizeIp',
      value: true,
    },
  ],
  // debug: {
  //   enabled: true, // default value
  //   trace: true, // default value
  //   sendHitTask: true // default value
  // }
}

export default (ctx, inject) => {
  Vue.use(VueAnalytics, {
    ...{ router: ctx.app.router },
    ...options,
  })

  ctx.$ga = Vue.$ga
  inject('ga', Vue.$ga)
}

Vue.prototype.optedOut = () => disabled

Vue.prototype.optOutGA = () => {
  document.cookie = `${disableStr}=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/; domain=${host}`
  Vue.$ga.disable()
}

Vue.prototype.optInGA = () => {
  document.cookie = `${disableStr}=true; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${host}`
  Vue.$ga.enable()
}
